import { Box, Button, CircularProgress } from "@mui/material";
import { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import LazyLoad from "react-lazy-load";
import { getEnvironmentVariable } from "../../../global/environmentVariables";
import { ImageCacheContext } from "../../../global/ImageCacheContext";

const COMPANY_FLAG = getEnvironmentVariable("COMPANY_FLAG");
const SYSTEM_IMAGES_CLOUDFRONT = getEnvironmentVariable(
  "SYSTEM_IMAGES_CLOUDFRONT"
);

const ImagePreview = (props) => {
  const { card, dense, large } = props;
  var imageCacheState = useContext(ImageCacheContext);
  const [loading, setLoading] = useState(true);
  const [image, setImage] = useState(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const go = async () => {
      if (!inView) return;
      setLoading(true);
      if (!card.imageFileId) {
        setImage({
          url: `${SYSTEM_IMAGES_CLOUDFRONT}/images/assets/cardback.png`,
        });
        setLoading(false);
        return;
      }

      if (image) {
        if (image.id === card.imageFileId) {
          setLoading(false);
          return;
        }
        setImage(null);
      }

      try {
        var file = card.imageFile?.id
          ? card.imageFile
          : card.image?.id
            ? card.image
            : await imageCacheState.fetchImage(
                card.imageFileId,
                large ? "large" : "medium"
              );
        if (file) {
          setImage({
            id: card.imageFileId,
            ...file,
          });
        }
      } catch (err) {
        //
      }
      setLoading(false);
    };

    go();
    // eslint-disable-next-line
  }, [inView]);

  return (
    <LazyLoad
      once
      onContentVisible={() => {
        setInView(true);
      }}
    >
      {!image?.url || loading ? (
        <Box
          sx={{
            flex: `0 0 ${large ? "286px" : dense ? "18px" : "214px"}`,
            width: large ? "286px" : dense ? "18px" : "214px",
            height: large ? "400px" : dense ? "24px" : "300px",
            mt: "-5px !important",
            borderRadius: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {loading && <CircularProgress size={10} />}
        </Box>
      ) : (
        <img
          src={image.url}
          alt={card.name}
          style={{
            flex: `0 0 ${large ? "286px" : dense ? "18px" : "214px"}`,
            width: large ? "286px" : dense ? "18px" : "214px",
            mt: "-5px !important",
            borderRadius: 2,
          }}
        />
      )}
    </LazyLoad>
  );
};

export default function FirstHand(props) {
  const { armyList, imageCache } = props;
  const [hand, setHand] = useState(null);
  const fetchHand = () => {
    let cards = [];
    let foundCharacter = false;
    if (armyList?.armyListContent) {
      for (let cardCategory of Object.values(armyList.armyListContent)) {
        if (cardCategory.cardType !== "Cosmic Avatar" && cardCategory.cards) {
          for (let card of Object.values(cardCategory.cards)) {
            let i = 1;
            if (!foundCharacter && card.id === armyList?.characterId) {
              foundCharacter = true;
              i++;
            }

            for (; i <= card.qty; i++) {
              cards.push({ ...card, random: Math.random() });
            }
          }
        }
      }
    }

    cards.sort((a, b) => {
      return a.random - b.random;
    });

    setHand(
      cards.slice(
        0,
        armyList?.character?.handSize || (COMPANY_FLAG === "shard-bugs" ? 7 : 6)
      )
    );
  };

  useEffect(() => {
    fetchHand();
    // eslint-disable-next-line
  }, []);

  return (
    <Box>
      <Box
        sx={{
          p: 1,
          textAlign: "center",
        }}
      >
        <Button onClick={fetchHand} variant="contained" color="primary">
          Redraw First Hand
        </Button>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          height: "325px",
          overflow: "auto",
          contain: "strict",
          overflowY: "hidden",
          "& img:not(:first-of-type)": {
            ml: 1,
          },
        }}
      >
        {hand?.length > 0 &&
          hand.map((card, index) => (
            <ImagePreview
              key={index + card.id}
              card={card}
              imageCache={imageCache}
            />
          ))}
      </Box>
    </Box>
  );
}
